'use client';
import { FavoriteItem, FavoriteType } from "@/types/favorites";
import { apiSwagger, customFetch } from "@/shared/api";
import { NEXT_PUBLIC_API_URL_CLIENT_SIDE } from "@/shared/envs";

// Auth is handled automatically by customFetch (injects Bearer token via /api/auth/token).
// No need to pass accessToken — callers guard login state before invoking these.

export const getFavoritesAction = async (): Promise<FavoriteItem[]> => {
  try {
    // Fetch ALL favorites (no type filter). We use customFetch directly because
    // the swagger-generated favoritesDetail(undefined) produces "/samples/favorites/undefined".
    const response = await customFetch(`${NEXT_PUBLIC_API_URL_CLIENT_SIDE}/samples/favorites`);
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      console.error('Failed to fetch favorites:', data?.msg || response.statusText);
      return [];
    }

    return data?.favorites ?? [];
  } catch (err) {
    console.error('Error fetching favorites:', err);
    return [];
  }
};

export const addFavoriteAction = async (
  favoriteId: string,
  favoriteType: FavoriteType
): Promise<Response | null> => {
  try {
    const response = await apiSwagger.samples.favoritesCreate({
      id: favoriteId,
      type: favoriteType
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      console.error('Failed to add favorite:', errorData?.msg || response.statusText);
      return null;
    }

    return response;
  } catch (err) {
    console.error('Error adding favorite:', err);
    return null;
  }
};

export const deleteFavoriteAction = async (
  favoriteId: string,
  favoriteType: FavoriteType
): Promise<Response | null> => {
  try {
    const response = await apiSwagger.samples.favoritesDelete(favoriteId, {type: favoriteType});

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      console.error('Failed to delete favorite:', errorData?.msg || response.statusText);
      return null;
    }

    return response;
  } catch (err) {
    console.error('Error deleting favorite:', err);
    return null;
  }
};
